import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from "react";
import ModuloDetailsArea from '../components/common/modulo/modulo-details';
import Cta from '../components/common/cta/cta';
import SEO from '../components/seo';
import Footer from '../layout/footers/footer';
import Header from '../layout/headers/header';
import Wrapper from '../layout/wrapper';
import { selectCourses } from '../redux/features/course-slice';
import { showCurso } from '../api/curso';
import { getCursosByMateria } from '../api/curso';
import { retrieveToken } from './../hooks/use-token';

const DynamicModuloDetails = () => {

  const { id } = useParams();
  const [curso, setCurso] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {

    const tokenApi = retrieveToken();

    if (curso == null) {
      showCurso(tokenApi, Number(id)).then(function(result) {
        setCurso(result);
      });
    }

});

  return (
    <Wrapper>
      {/* seo start */}
      <SEO pageTitle={'Módulos do Curso'} />
      {/* seo end */}

      {/* header start */}
      <Header header_shadow={true} />
      {/* header end */}

      {/* modulo details */}
      <ModuloDetailsArea curso={curso} />
      {/* modulo details */}

      {/* footer start */}
      <Footer />
      {/* footer end */}
    </Wrapper>
  );
};

export default DynamicModuloDetails;